import { TokenDataPermissions, useTokenData } from 'store/state';

export const useHasPermission = () => {
  const tokenData = useTokenData();

  return (
    // permissionName: keyof TokenDataPermissions,
    permissionName: string,
    permissionFunctionality?: number
  ): boolean => {
    if (!tokenData) return false;

    const permissions = tokenData[permissionName as keyof typeof tokenData];

    if (!permissions) return false;

    if (typeof permissions === 'string') {
      return permissionFunctionality
        ? permissions.includes(permissionFunctionality.toString())
        : true;
    }

    if (Array.isArray(permissions)) {
      return permissionFunctionality
        ? permissions.includes(permissionFunctionality.toString())
        : true;
    }

    return false;
  };
};
